export default "/images/69ce8803eb9f75e935bfb306010ae86c.avif";